import React from "react";
import { Form, FormItem, Select } from "formik-antd";
import { Button, Form as AntForm } from "antd";
import { formItemLayout, tailFormItemLayout } from "../../utils";
import { Formik } from "formik";
import * as Yup from "yup";
import { useTranslate } from "../../hooks";

const SYSTEM_SETTING_CODES = [
  { value: "PAYMENT_MODE", label: "決済モード" },
  { value: "3DS_CHALLENGE_IND_TYPE", label: "3DS2.0認証チャレンジ要求タイプ" },
];

const VALUE_OPTIONS = {
  PAYMENT_MODE: [
    { value: "GMOV1", label: "３DSなし" },
    { value: "GMOV2", label: "３DSあり" },
  ],
  "3DS_CHALLENGE_IND_TYPE": [
    { value: "1", label: "1 - 認証必須" },
    { value: "2", label: "2 - 認証必須ではない" },
  ],
};

const SystemSettingForm = ({ action, onSubmit, onCancel }) => {
  const { translate } = useTranslate();
  const [data] = React.useState({
    code : undefined,
    value: undefined,
    ...(action && action[0] === "update" ? action[1] : {})
  });

  const FormSchema = () => Yup.object({
    code : Yup.string().required(translate("system.regex.required", "required field")),
    value: Yup.string().required(translate("system.regex.required", "required field")),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={data}
      validationSchema={FormSchema}
      onSubmit={onSubmit}>
      {({ isSubmitting, values, setFieldValue }) => {
        return (
          <Form {...formItemLayout}>
            <FormItem name="code" label={translate("system.setting.form.code", "コード")} required>
              <Select
                disabled={action && action[0] === "update"}
                name="code"
                placeholder={translate("system.setting.form.code.placeholder", "コードを選択")}
                onChange={(val) => {
                  setFieldValue("code", val);
                  setFieldValue("value", undefined);
                }}>
                {SYSTEM_SETTING_CODES.map((item) => (
                  <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
                ))}
              </Select>
            </FormItem>
            <FormItem name="value" label={translate("system.setting.form.value", "値")} required>
              {values.code === "PAYMENT_MODE" && (
                <Select name="value" placeholder={translate("system.setting.form.value.placeholder", "値を選択")}>
                  {VALUE_OPTIONS.PAYMENT_MODE.map((item) => (
                    <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
                  ))}
                </Select>
              )}
              {values.code === "3DS_CHALLENGE_IND_TYPE" && (
                <Select name="value" placeholder={translate("system.setting.form.value.placeholder", "値を選択")}>
                  {VALUE_OPTIONS["3DS_CHALLENGE_IND_TYPE"].map((item) => (
                    <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
                  ))}
                </Select>
              )}
              {!values.code && (
                <Select name="value" placeholder={translate("system.setting.form.select.code.first", "先にコードを選択してください")} disabled />
              )}
            </FormItem>
            <AntForm.Item {...tailFormItemLayout}>
              <Button className="button" style={{ marginRight: 10 }} htmlType="submit" type="primary" loading={isSubmitting}>{translate("system.btn.save", "Save")}</Button>
              <Button className="button" type="default" onClick={onCancel}>{translate("system.btn.cancel", "Cancel")}</Button>
            </AntForm.Item>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SystemSettingForm;
